import { Swiper, SwiperSlide } from 'swiper/react'
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  EffectFade,
} from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'
import { Box, Image } from '@chakra-ui/react'
import { ContainerImage } from './styles'

export function SlideImages({ images }) {
  function formatNameFile(name) {
    if (name.length <= 20) return name

    const extension = name.split('.').pop() // Obtém a extensão do arquivo
    const fileNameWithoutExtension = name.slice(
      0,
      name.length - extension.length - 1
    ) // Remove a extensão do nome do arquivo
    const truncatedName =
      fileNameWithoutExtension.slice(0, 10) +
      '...' +
      fileNameWithoutExtension.slice(-3)

    return truncatedName + '.' + extension
  }

  return (
    <Swiper
      modules={[Navigation, Pagination, Scrollbar, A11y]}
      spaceBetween={50}
      slidesPerView={1}
      onSlideChange={() => console.log('asd')}
      style={{
        width: '700px',
        height: '100%',
      }}
      navigation
      pagination={{ clickable: true }}
    >
      {images?.map((image, index) => (
        <SwiperSlide
          key={index}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ContainerImage>
            <Image
              rounded="md"
              src={URL.createObjectURL(image)}
              alt={image.name}
              border="1px solid #0000001A"
              p="1rem"
            />
          </ContainerImage>

          <Box
            position="absolute"
            bottom="0"
            right="0"
            bg="#00000045"
            color="white"
            fontSize="1rem"
            p="0.5rem 1rem"
            rounded="md"
            zIndex="1"
          >
            {formatNameFile(image?.name)}
          </Box>
        </SwiperSlide>
      ))}
      {/* {quantityImages.quantity > 1 && (
        <Box
          position="absolute"
          bottom="0"
          right="0"
          bg="#0000001A"
          color="white"
          fontSize="1rem"
          p="0.5rem 1rem"
          rounded="md"
          zIndex="1"
        >
          {quantityImages.current + 1}/{quantityImages.quantity}
        </Box>
      )} */}
    </Swiper>
  )
}
